export default "__VITE_ASSET__D_5mwyjj__"